//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import ReferalTextBlock from "~/cms/blocks/ReferalTextBlock.vue";
import ReferalHeadingBlock from "~/cms/blocks/ReferalHeadingBlock.vue";
import ReferalConditionsBlock from "~/cms/blocks/ReferalConditionsBlock.vue";

export default BaseCmsBlock.extend({
  name: "ReferalBlock",

  fetch: async function () {
    const isUseHashLink = Boolean((this.values?.tabs || []).find((t) => Boolean(Number.parseFloat(t.use_hash_link || 0))));
    if (!isUseHashLink) {
      return
    }

    const query = this.$route?.query?.r || "";
    if (!query) {
      this.$nuxt.context.error({
        statusCode: 404,
        message: this.$t('errorPage.pageNotFound')
      })
      return
    }

    await this.getHashLink();
  },

  data: function () {
    return {
      linkFromHash: "",
      activeIndex: 0,
    }
  },

  computed: {
    valuesReferalHeadingBlock: function () {
      return {
        tabs: this.values.tabs
      }
    },
    valuesReferalConditionsBlock: function () {
      const tab = this.values?.tabs?.[this.activeIndex];
      return {
        title: tab.conditions_title,
        conditions: (tab?.conditions || [])
      }
    },
    valuesReferalTextBlock: function () {
      const tab = this.values?.tabs?.[this.activeIndex];
      return {
        title: tab.text_block_title,
        items: (tab?.text_block_items || []),
        use_bg: Boolean(tab?.text_block_background)
      }
    },
  },

  components: {
    ReferalTextBlock,
    ReferalHeadingBlock,
    ReferalConditionsBlock
  },

  methods: {
    getHashLink: async function () {
      const isUseHashLink = Boolean((this.values?.tabs || []).find((t) => Boolean(Number.parseFloat(t.use_hash_link || 0))));
      if (!isUseHashLink) {
        return
      }
      const query = this.$route?.query?.r || "";
      const res = await this.$api.agent.transport.get(`/sms-users/get-link-from-hash?hash=${query}`).then((res) => {
        return res.data
      }).catch(() => {
        return ""
      });
      if (!res) {
        this.$nuxt.context.error({
          statusCode: 404,
          message: this.$t('errorPage.pageNotFound')
        });
        return
      }
      this.linkFromHash = res;
    },

    changeSection: function (idx) {
      this.activeIndex = idx;
    },
  }
})
